/**
 * Dashboard görüntüleyicinin hafif girişi: DevExpress paketleri (~MB) yalnızca bir
 * dashboard açıldığında indirilir. Ağır iş `DashboardViewerHost` içinde.
 */
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/shared/ui/EmptyState';
import { ScreenLoader } from '@/shared/ui/ScreenLoader';
import { usePrefsStore } from '@/entities/preferences/model/prefsStore';
import { resolveTheme } from '@/entities/preferences/lib/applyPrefs';
import type { DashboardViewerHostProps } from './DashboardViewerHost';

const DashboardViewerHost = lazy(() => import('./DashboardViewerHost'));

export function DashboardViewer({ dashboardId, refreshIntervalSec, designer }: DashboardViewerHostProps) {
  const { t } = useTranslation();
  // Görüntüleyici uygulamanın tema ve dilini izler (rapor görüntüleyiciyle aynı kural).
  const theme = usePrefsStore((s) => s.prefs.theme);
  const language = usePrefsStore((s) => s.prefs.language);

  if (!dashboardId) return <EmptyState title={t('dashboard.notFound')} />;

  return (
    <Suspense
      fallback={
        <ScreenLoader kind="dashboard" className="h-full min-h-40" />
      }
    >
      <DashboardViewerHost
        dashboardId={dashboardId}
        refreshIntervalSec={refreshIntervalSec}
        designer={designer}
        dark={resolveTheme(theme) === 'dark'}
        language={language}
      />
    </Suspense>
  );
}
